// src/redux/action/admin/staff/type.js
export const SET_ALL_DATA_OF_ADMIN_STAFF = "SET_ALL_DATA_OF_ADMIN_STAFF";
export const SET_STAFF_ADMIN_STAFF = "SET_STAFF_ADMIN_STAFF";
export const SET_FILTERED_ADMIN_STAFF = "SET_FILTERED_ADMIN_STAFF";
export const SET_PAGES_DATA_ADMIN_STAFF = "SET_PAGES_DATA_ADMIN_STAFF";
export const RESET_ALL_ADMIN_STAFF_DATA = "RESET_ALL_ADMIN_STAFF_DATA";
export const SET_SHOULD_REFRESH_ADMIN_STAFF = 'SET_SHOULD_REFRESH_ADMIN_STAFF'